var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2331 14.625C15.2632 14.6172 17.8396 16.0085 18.7866 19.0033C16.8778 20.167 14.631 20.6152 12.2331 20.6093C9.83535 20.6152 7.5885 20.167 5.67969 19.0033C6.62779 16.0052 9.19983 14.6172 12.2331 14.625Z",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8446 13.7735C4.72023 13.768 2.91394 14.7434 2.25 16.8431C2.97469 17.2849 3.76887 17.5796 4.61172 17.7563",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 13.7735C19.7806 13.768 21.5869 14.7434 22.2508 16.8431C21.5261 17.2849 20.7319 17.5796 19.8891 17.7563",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3493 7.49297C16.3493 9.75648 14.5143 11.5915 12.2508 11.5915C9.98727 11.5915 8.15234 9.75648 8.15234 7.49297C8.15234 5.22946 9.98727 3.39453 12.2508 3.39453C14.5143 3.39453 16.3493 5.22946 16.3493 7.49297Z",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7338 6.04937C17.0234 5.9515 17.3336 5.89844 17.6563 5.89844C19.2469 5.89844 20.5363 7.18785 20.5363 8.77842C20.5363 10.369 19.2469 11.6584 17.6563 11.6584C16.8833 11.6584 16.1814 11.3539 15.6641 10.8582",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50078 5.97347C7.29007 5.92439 7.07048 5.89844 6.84482 5.89844C5.25425 5.89844 3.96484 7.18785 3.96484 8.77842C3.96484 10.369 5.25425 11.6584 6.84482 11.6584C7.53804 11.6584 8.17406 11.4135 8.67106 11.0055",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.4d6d048ae9b280a4e5328b09b5c4e0a4.svg";
export { ForwardRef as ReactComponent };